import { getLocaleExtraDayPeriods } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { ApiUrlConstant } from '@app-constants/app.constants';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { apisDataCacheKeys, scoreExamData } from '@app-constants/app.constants';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import * as moment from 'moment';
import { UserService } from '@app-services/user/user.service';
import { isUserAdmin } from '@app-helpers/functions';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PaymentalreadypaidComponent } from '@app-shared/components/paymentalreadypaid/paymentalreadypaid.component';
import { FirebaseService } from '@app-services/firebase/firebase.service';


export interface ICustomWindow extends Window {
  __custom_global_stuff: string;
}

function getWindow(): any {
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  apiUrl = ApiUrlConstant.omsdevapi;
  liveClassapi = ApiUrlConstant.LIVE_CLASS_API;
  newApiUrl = ApiUrlConstant.newApiUrl;
  stageeosapi = ApiUrlConstant.stageeosapi;
  public rzp: any;
  public options:any;
  subcriptionPayment:any;
  public subscriptionSelectedData :any = {
    offerings :['Assessment','Live Classes', 'recordedCourse', 'Hardware', 'selflearn']
  };
  public userDetails :any= {}
  public filterSuubscriptionSubject = new Subject();
  public filterSuubscriptionObserable = this.filterSuubscriptionSubject.asObservable();
  // public backClicked = new BehaviorSubject<string>('');
  public backClicked = new Subject();
  public isFromScoreGiftPopup = false;
  public addressEditbillingSubject = new Subject();
  public addressSubscriptionObserable$ = this.addressEditbillingSubject.asObservable();
  public addressEditingSubject = new Subject();
  public addressEditingObserable$ = this.addressEditingSubject.asObservable();
  public saveAddressSubject = new Subject();
  public saveAddressObserable$ = this.saveAddressSubject.asObservable();
  public validAddressSubject = new Subject();
  public validAddressObserable$ = this.validAddressSubject.asObservable();
  public checkShippingSubject = new Subject();
  public checkShippingObserable$ = this.checkShippingSubject.asObservable();
  public hasCouponSubject = new Subject();
  public hasCouponObserable$ = this.hasCouponSubject.asObservable();
  public giftCouponCode:any = '';
  public hasCouponCode:string = '';
  public scoreExamdetaildata :any ={}
  backClickedInBilling = this.backClicked.asObservable();
  batchDetailsVars:any;
  validDateForSingleCourse:any;
  cartFlowSelectedPackage :any = {};
  isSubscriptionRenewed: boolean = false;
  oldUserOrderMasterId: number = 0;
  oldSubscriptionId: number = 0;
  scoreSelectionDetails :any  = {
    timeSlots :[],
    selectedScoresExams:[],
    editType:'',
    allCartItems:[],
    allWishlistItems:[]
  }
  proplusSelectionDetails :any  = {
    timeSlots :[],
    selectedScoresExams:[],
    editType:'',
    allCartItems:[],
    allWishlistItems:[]
  }
  userAddedAdress :any =[];
  pincodeMapData: any = new Map();

  replacingPkg:boolean = false;
  replacingCartItem:any;
  selectedPackForReplacement:boolean = false;
  constructor(public httpclient: HttpClient,private zone: NgZone,public router: Router, public spinner: NgxSpinnerService, private userService: UserService, public matdialog: MatDialog, public firebaseService:FirebaseService){
    let userDetails = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    this.userDetails = userDetails;


  }
  get nativeWindow(): any {
    return getWindow();
  }
  getAllExams(param){
    return this.httpclient.get(this.apiUrl+'targetexams',{params:param}).pipe(catchError(this.handleError))
  }
  getSubscriptions(params:any){
    return this.httpclient.get(this.apiUrl+'packages/subscriptions',{params: params}).pipe(catchError(this.handleError))
  }
  userorders(body:any){
    body.userPlatform = body?.portal||'studentportal';
    return this.httpclient.post(this.apiUrl+'userorders',body).pipe(catchError(this.handleError))
  }

  updateUserorders(body:any){
    return this.httpclient.put(this.apiUrl+'userorders/updateUserOrder',body).pipe(catchError(this.handleError))
  }

  updateAdvancedEMIOrder(body: any){
    return this.httpclient.post(this.apiUrl+'userorders/updateAdvancedEMIOrder',body).pipe(catchError(this.handleError))
  }

  createCoupon(body){
    return this.httpclient.post(this.apiUrl+'discountcodes/createCode',body).pipe(catchError(this.handleError))
  }

  validateDiscountCode(body:any){
    return this.httpclient.post(this.apiUrl+'discountcodes/validateDiscountCode',body).pipe(catchError(this.handleError))
  }
  calulateDiscountForCartItemUsingGET(param:any){
    return this.httpclient.get(this.apiUrl+'discountcodes/calulateDiscountForCartItem',{params:param}).pipe(catchError(this.handleError))
  }
  userPayment(body:any,grade?){
    let getuserdetails = this.getuserDetails();
    body.grade  = grade ? grade : getuserdetails?.grade?.name?.split('th')?.[0];
    body.studentId = getuserdetails?.userId;
    body.tenantID = environment.tenant;
    body.portal = body?.portal||'studentportal';
    body.subscriptionRenewed = this.isSubscriptionRenewed;
    body.oldUserOrderMasterId = this.oldUserOrderMasterId;
    body.oldSubscriptionId = this.oldSubscriptionId;
    return this.httpclient.post(this.apiUrl+'payments',body).pipe(catchError(this.handleError))
  }

  userPaymentV2(body:any,grade?){
    let getuserdetails = this.getuserDetails();
    body.grade  = grade ? grade : getuserdetails?.grade?.name?.split('th')?.[0];
    body.studentId = getuserdetails?.userId;
    body.tenantID = environment.tenant;
    body.portal = body?.portal||'studentportal';

    return this.httpclient.post(this.apiUrl+`payments${environment?.doBajajEncryption ? "/v2" : ""}`,body).pipe(catchError(this.handleError))
  }

  userPaymentV3(body:any,grade?){
    let getuserdetails = this.getuserDetails();
    body.grade  = grade ? grade : getuserdetails?.grade?.name?.split('th')?.[0];
    body.studentId = getuserdetails?.userId;
    body.tenantID = environment.tenant;
    body.portal = body?.portal||'studentportal';
    let url = environment?.useV1API ? this.apiUrl+'payments' : this.apiUrl+'payments/v2';
    return this.httpclient.post(url,body).pipe(catchError(this.handleError))
  }

  downloadInvoice(orderId:string){
    let headers = {
      'Content-Type': 'application/pdf',
    };
    return this.httpclient.get(this.apiUrl+'invoice/cart/'+orderId,{headers:headers,responseType: 'blob'}).pipe(catchError(this.handleError))
  }

  getSubscribedPackages(id:string){
    this.userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    let grade = this.userDetails?.grade?.name?.split('th')?.[0];
    return this.httpclient.get(this.apiUrl+'userorders/'+id+'?grade='+grade).pipe(catchError(this.handleError))
  }


  getMySubscribedPackages(id:string){
    this.userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    let grade = this.userDetails?.grade?.name?.split('th')?.[0];
    grade = grade?.replace(/[^0-9]/g, '');
    return this.httpclient.get(this.apiUrl+'userorders/mySubscription?grade='+grade+'&userId='+this.userDetails?.userId).pipe(catchError(this.handleError))
  }

  checkSubscriptions(examId: any){
    this.userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    let grade = this.userDetails?.grade?.name?.split('th')?.[0];
    const payload = {
      gradeno: grade,
      product_Type: "selflearn",
      uam_exam_id: examId,
      userId: this.userDetails?.userId,
    }
    return this.httpclient.post(this.apiUrl+'check-subscriptions', payload).pipe(catchError(this.handleError))
  }

  totalexamTypePackages(params,grade?){
    let getuserdetails =  this.getuserDetails();
    params.grade = grade ? grade: getuserdetails?.grade?.name?.split('th')?.[0];
    params.grade =  params.grade?.replace(/[^0-9]/g, '');
    return this.httpclient.get(this.apiUrl+'packages/subscriptionsByYear' ,{params:params}).pipe(catchError(this.handleError))
  }

  // for Enollnow Subscription only not for unified
  getPackageDetails(params, grade?) {
    let url = this.apiUrl;
    let suburl = url.replace("api/","open/");
    let getuserdetails = this.getuserDetails();
    params.grade = grade ? grade : getuserdetails?.grade?.name?.split('th')?.[0];
    return this.httpclient.get(suburl + 'features/getOpenPackagesAndSubscriptions', { params: params }).pipe(catchError(this.handleError))
  }

  getPackagesSubscriptionByPackageId(params){
    return this.httpclient.get(this.apiUrl+'packages/getPackageAndSubcriptionDetailByPackageId' ,{params:params}).pipe(catchError(this.handleError))
  }
    getfaq(){
    return this.httpclient.get(this.apiUrl+'faq/getFAQ?productType='+this.subscriptionSelectedData.offerings?.join(',')?.toLowerCase()?.replaceAll(" ", "")).pipe(catchError(this.handleError))
  }
  getUserAutofilldetails() {
    let userProfileData = {
      years: [],
      examsType: [],
    };
    let userDetails = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    userProfileData.years = (userDetails?.grade?.name == '12th'  || userDetails?.grade?.name == '13th' ) ? ([2022]) : userDetails?.grade?.name == '11th' ? [2023] : userDetails?.grade?.name == '10th' ? [2024] : userDetails?.grade?.name == '9th' ? [2025]:[];
    userProfileData.examsType = userDetails?.exams.map(exam => exam?.name);
    this.userDetails = userDetails;
    return userProfileData;
  }
  setPackageDetails(object:any){
      this.subscriptionSelectedData = object
  }
  updatePackagesSubcription(){
    this.filterSuubscriptionSubject.next(true);
  }
  fetchAllCoursesData(courelist, userID?){  //hard coded
    if(userID){
      return this.httpclient.get(this.liveClassapi+'courses/'+courelist+'/courses?student='+userID).pipe(catchError(this.handleError))
    }else{
      return this.httpclient.get(this.liveClassapi+'courses/'+courelist+'/courses').pipe(catchError(this.handleError))
    }
  }
  fetchBatchDetails(id,userID?){
    if(userID){
      return this.httpclient.get(this.liveClassapi+'courses/batches/'+id+'?student='+userID).pipe(catchError(this.handleError))
    }else{
      return this.httpclient.get(this.liveClassapi+'courses/batches/'+id).pipe(catchError(this.handleError));
    }
  }
  blockCourseEnrollment(body:any){
    return this.httpclient.post(this.liveClassapi+'studentEnrollment/block-course-enrollment',body).pipe(catchError(this.handleError))
  }
  liveClassEnrollStudent(body){
     return this.httpclient.post(this.liveClassapi+'studentEnrollment',body).pipe(catchError(this.handleError))
  }
  getPackagesSubscriptionByUserID(params){
  return this.httpclient.get(this.apiUrl+'packages/getPackagesSubscriptionByUserID',{params:params}).pipe(catchError(this.handleError));
  }
  getuserDetails(){
    let userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    return userDetails
  }
  getGrade(){
    let userDetails = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    let grade = (userDetails?.grade?.name == '12th'  || userDetails?.grade?.name == '13th' ) ? ([2022]) : userDetails?.grade?.name == '11th' ? [2023] : userDetails?.grade?.name == '10th' ? [2024] : userDetails?.grade?.name == '9th' ? [2025]:[];
    return grade;
  }
  paymentABortedbyUser(body){
    return this.httpclient.post(this.apiUrl+'payments/cartPaymentAborted',body).pipe(catchError(this.handleError))
  }
  handleError(err:any){
    return throwError(err)
  }

  getPartialPayments(packageId,durationId){
    return this.httpclient.get(this.apiUrl+'packages/getPartpaymentDetailsByPackageId?packageId='+packageId+'&packageSubscriptionId='+durationId).pipe(catchError(this.handleError))
  }

  //common code for razorpay
  setRazorpayOptions(subscriptionbillingUtility){
  this.subcriptionPayment=subscriptionbillingUtility;
  let emiData = this.subcriptionPayment.paidOptions;
  let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
  this.options = {
    key: environment.razorkey,// 'rzp_live_NoGaIDZ74lwGZa',//"rzp_test_9y0agtAfQDcO5L",//rzp_test_tiOVruBsu1t5PB -radha',rzp_live_NoGaIDZ74lwGZa-staging // add razorpay key here
    name: subscriptionbillingUtility.userDetails.firstName + ' ' + subscriptionbillingUtility.userDetails.lastName,
    description: 'Subscription',
    amount: 100, // razorpay takes amount in paisa
    prefill: {
      name: subscriptionbillingUtility.userDetails?.firstName + ' ' + subscriptionbillingUtility.userDetails?.lastName,
      email: subscriptionbillingUtility.userDetails?.email || '', // add your email id
      contact: subscriptionbillingUtility.userDetails?.phone
    },
    notes: {},
    theme: {
      color: '#3880FF'
    },
    "order_id": subscriptionbillingUtility.generatedOrderDetails.gatewayOrderId,
    handler: this.paymentHandler.bind(this),
    modal: {
      ondismiss: (() => {
        this.onPaymentFailure(subscriptionbillingUtility, this.options);
      })
    }
  }

  //create order id
  this.rzp = new this.nativeWindow['Razorpay'](this.options);
    this.rzp.open();
    this.rzp.on('payment.failed', (response: any) => {
    });
}

  paymentHandler(subscriptionbillingUtility: any, res: any, options: any) {
    this.subcriptionPayment=subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    this.options = options;
    this.zone.run(() => {
      if (res?.razorpay_signature) {
        var obj = {
          "gatewayCode": "RAZORPAY",
          "paymentMode": "ONLINE",
          "razorpayOrderId": res?.razorpay_order_id,
          "razorpayPaymentId": res?.razorpay_payment_id,
          "razorpaySignature": res?.razorpay_signature,
          "userOrderId": this.subcriptionPayment.orderId,
          "batchId": this.subcriptionPayment?.selectedBatch?.id ?? '',
          "ruleID": this.subcriptionPayment.selectedPackage?.id ?? '',
          "userOrderPaymentPlanCaptureDetailsRequest": this.subcriptionPayment.payValue == 'fullpayment' ?
            [{
              "paidAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
              "partAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
              "partPlanDetailsId": this.subcriptionPayment.fullPaymentOptions?.planDetailId
            }]
            : this.subcriptionPayment.emiOptions?.map((val, index) => {
              return {
                "paidAmount": index == 0 ? val?.amount : 0,
                "partAmount": val?.amount,
                "partPlanDetailsId": val?.planDetailId
              }
            }) ?? [],
          "paymentPlanCaptureDetailsId": this.subcriptionPayment.payValue == 'fullpayment' ? this.subcriptionPayment.fullPaymentOptions?.planDetailId : this.subcriptionPayment.emiOptions?.[0]?.planDetailId,
          "encryption": "",
          jodoProductType: undefined,
          encrypted: false
        }
        this.userPayment(obj).subscribe({
        next: (resp: any) => {
         if (!this.subcriptionPayment.selectedPackage) {
           this.subcriptionPayment.selectedPackage = { status: 'success' };
         }else{
          this.subcriptionPayment.selectedPackage.status = 'success';
         }
          this.subcriptionPayment.paymentStatusCapture=resp;
          // if(this.subscriptionSelectedData?.liveclass_courseID) {
            // this.spinner.show();

            this.subcriptionPayment?.allCartItems?.forEach(async (ele) => {
              if (ele?.courseId && ele?.batchId) {
                let userDetails = this.getuserDetails();
                let body = {
                  "courses": ele?.courseId,
                  "batches": ele?.batchId,
                  "student": {
                    "id": this.userDetails?.userId?.toString() ||  userDetails?.userId?.toString(),
                    "firstName": this.userDetails?.firstName || userDetails?.firstName,
                    "lastName": this.userDetails?.lastName || userDetails?.lastName,
                  },
                  "tenant": environment?.tenant,

                }
              }

              // for multiple score packages
              if (ele?.scoreId) {

                    let userData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
                    let userBillingDetails = JSON.parse(localStorage.getItem('billing-address-try-again'));
                    let examDt =  this.subcriptionPayment.userCartAddedScorePackageTimeslots[ele?.scoreId]?.span;
                    isUserAdmin(this.userService).then((bool) => {
                      if(!bool) {
                        let payload = {
                          data: {
                            score_exam_type: 'SCHOLARSHIPTEST',
                            score_target_exam: localStorage.getItem('targetExamName'),
                            score_exam_date: moment(examDt, "YYYY-MM-DD hh:mm A").format("DD-MMM-YYYY")+' ('+moment(examDt, "YYYY-MM-DD hh:mm A").format("dddd")+')',
                            score_time_slot: moment(examDt, "YYYY-MM-DD hh:mm A").format("hh:mm A")+ ' (' + (this.subcriptionPayment.userCartAddedScorePackageTimeslots[ele?.scoreId]?.slot)+').',
                            score_mode_of_exam: 'online',
                            score_grade: 'Grade '+ userData?.grade?.name?.replace('th', ''),
                            score_email_id: userData?.email || userBillingDetails?.email,
                            score_address: userBillingDetails?.addressLine1,
                            score_city: userBillingDetails?.cityName || null,
                            score_pincode:userBillingDetails?.pinCode,
                            score_district:userBillingDetails?.district,
                            score_state: userBillingDetails?.statename || null,
                            score_school_name: null,
                            phone_number:userBillingDetails?.phone,
                            score_coupon_code:this.subcriptionPayment?.discountCode||''
                          },
                          "landingPage" : "LSQ_CUSTOM_EVENTS"
                        }
                        this.userService.callTrackingAPI2(userData.userId, payload, 'Act_Score').subscribe((data)=>{console.log(data)});
                      }
                    })
              }
              this.spinner.hide(); // start at subscription-payment.component 588(cross-file)
              if(this.subcriptionPayment?.allCartItems?.length >1){
                this.router.navigate(['./subscription/payementVerification'],
                  { ...this.subcriptionPayment.selectedPackage, ...this.subcriptionPayment.selectedDuration, ...this.options, ...{ userOrderId: obj?.userOrderId }, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture },...{paymentStatusCapture:this.subcriptionPayment.paymentStatusCapture},...{productSet:this.subcriptionPayment.selectedPackage.productSet}, ...{singleCourse:false}, ...{downloadInvoiceUserOrderID: resp?.userOrder?.id}, ...{ paymentGatewayCode: "RAZORPAY"}, })
              }else{
                  this.router.navigate(['./subscription/payementVerification'],
                  { ...this.subcriptionPayment.selectedPackage, ...this.subcriptionPayment.selectedDuration, ...this.options, ...{ userOrderId: obj?.userOrderId }, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture },...{paymentStatusCapture:this.subcriptionPayment.paymentStatusCapture},...{productSet:this.subcriptionPayment.selectedPackage.productSet}, ...{singleCourse:true}, ...{downloadInvoiceUserOrderID: resp?.userOrder?.id}, ...{ paymentGatewayCode: "RAZORPAY"},
                  ...{expiryApplicableOnValidityDate: this.subcriptionPayment?.allCartItems?.[0]?.subscription?.expiryApplicableOnValidityDate},})
               }
            })

      },
      error:(err)=>{
        //? checking cartcount
        this.spinner.hide();
        if(this.subcriptionPayment?.allCartItems?.length >1){
          this.router.navigate(['./subscription/payementVerification'],
          { ...this.subcriptionPayment.selectedPackage, ...this.subcriptionPayment.selectedDuration, ...this.options, ...{ userOrderId: obj?.userOrderId }, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture },...{paymentStatusCapture:this.subcriptionPayment.paymentStatusCapture},...{productSet:this.subcriptionPayment.selectedPackage.productSet},
          ...{singleCourse:false},
          ...{ paymentGatewayCode: "RAZORPAY"},
        })
        }else{
          this.router.navigate(['./subscription/payementVerification'],
          { ...this.subcriptionPayment.selectedPackage, ...this.subcriptionPayment.selectedDuration, ...this.options, ...{ userOrderId: obj?.userOrderId }, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture },...{paymentStatusCapture:this.subcriptionPayment.paymentStatusCapture},...{productSet:this.subcriptionPayment.selectedPackage.productSet}, ...{singleCourse:true}, ...{ paymentGatewayCode: "RAZORPAY"},
          ...{expiryApplicableOnValidityDate: this.subcriptionPayment?.allCartItems?.[0]?.subscription?.expiryApplicableOnValidityDate} })
        }

      }
       })
    }
  });
}

  onPaymentFailure(subscriptionbillingUtility, options: any) {
    this.zone.run(() => {
      // add current page routing if payment fails
      this.subcriptionPayment = subscriptionbillingUtility;
      let emiData = this.subcriptionPayment.paidOptions;
      let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
      this.options = options;
      if (!subscriptionbillingUtility.selectedPackage) {
        subscriptionbillingUtility.selectedPackage = {};
      }
      subscriptionbillingUtility.selectedPackage.status = 'error';
      let routing = {
        billingAddress: subscriptionbillingUtility.billingAddress,
        selectedPin: subscriptionbillingUtility.selectedPin,
        selectedState: subscriptionbillingUtility.selectedState,
      };
      let body = {
        amount: subscriptionbillingUtility.selectedPackage?.amount,
        creationDate: new Date().toISOString(),
        status: 'aborted',
        userId: this.userDetails?.userId,
        userOrderId: subscriptionbillingUtility.orderId,
        grade: this.userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
        reason: subscriptionbillingUtility?.error?.reason || "Payment processing cancelled by user",
        description: subscriptionbillingUtility?.error?.description || "Payment processing cancelled by user",
      };
      var mresp;
      this.paymentABortedbyUser(body).subscribe((resp: any) => {
        console.log('aborted by user', resp);
        mresp=resp; //?storing the response
        //? checking cartcount
        this.spinner.hide();
        if (this.subcriptionPayment?.allCartItems?.length > 1) {
          console.log('multiple Courses!');
          this.router.navigate(['./subscription/payementVerification'], {
            ...this.subcriptionPayment.selectedPackage,
            ...this.subcriptionPayment.selectedDuration,
            ...this.options,
            ...{ emiData: emiData },
            ...{ planDetailsCapture: planDetailsCapture },
            ...{
              paymentStatusCapture:
                this.subcriptionPayment.paymentStatusCapture,
            },
            ...{
              productSet: this.subcriptionPayment.selectedPackage.productSet,
            },
            ...{ totalAmount: this.subcriptionPayment.totalAmount },
            ...{ fulltotalAmount: this.subcriptionPayment.totalPaidAmount },
            ...{ selectedCartItems: this.subcriptionPayment.selectedCartItems }, //? for course details
            ...{paymentFailed:mresp.userOrderPackageSubscriptionList},
            ...{ singleCourse: false },
            ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData },
            ...{ failureMessage: resp?.failureMessage || subscriptionbillingUtility?.error?.description || "" },
            ...{ paymentGatewayCode: "RAZORPAY"},
          });
        } else {
          console.log('single Course!');
          this.router.navigate(['./subscription/payementVerification'], {
            ...this.subcriptionPayment.selectedPackage,
            ...this.subcriptionPayment.selectedDuration,
            ...this.options,
            ...{ emiData: emiData },
            ...{ planDetailsCapture: planDetailsCapture },
            ...{
              paymentStatusCapture:
                this.subcriptionPayment.paymentStatusCapture,
            },
            ...{
              productSet: this.subcriptionPayment.selectedPackage.productSet,
            },
            ...{ totalAmount: this.subcriptionPayment.totalAmount },
            ...{ fulltotalAmount: this.subcriptionPayment?.totalPaidAmount },
            ...{ singleCourse: true },
            ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData },
            ...{ failureMessage: resp?.failureMessage || subscriptionbillingUtility?.error?.description || "" },
            ...{ paymentGatewayCode: "RAZORPAY"},
            ...{expiryApplicableOnValidityDate: this.subcriptionPayment?.allCartItems?.[0]?.subscription?.expiryApplicableOnValidityDate}
          });
        }
      }, (err) => {
        //? checking cartcount
        this.spinner.hide();
        if (this.subcriptionPayment?.allCartItems?.length > 1) {
          console.log('multiple Courses!');
          this.router.navigate(['./subscription/payementVerification'], {
            ...this.subcriptionPayment.selectedPackage,
            ...this.subcriptionPayment.selectedDuration,
            ...this.options,
            ...{ emiData: emiData },
            ...{ planDetailsCapture: planDetailsCapture },
            ...{
              paymentStatusCapture: this.subcriptionPayment.paymentStatusCapture,
            },
            ...{ productSet: this.subcriptionPayment.selectedPackage.productSet },
            ...{ totalAmount: this.subcriptionPayment.totalAmount },
            ...{ fulltotalAmount: this.subcriptionPayment.totalPaidAmount },
            ...{ selectedCartItems: this.subcriptionPayment.selectedCartItems }, //? for course details
            ...{paymentFailed:mresp.userOrderPackageSubscriptionList},
            ...{
              singleCourse: false,
              payValue: subscriptionbillingUtility?.payValue,
            ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData },
            ...{ failureMessage: subscriptionbillingUtility?.error?.description || "" },
            },
          });
        } else {
          console.log('single Course!');
          this.router.navigate(['./subscription/payementVerification'], {
            ...this.subcriptionPayment.selectedPackage,
            ...this.subcriptionPayment.selectedDuration,
            ...this.options,
            ...{ emiData: emiData },
            ...{ planDetailsCapture: planDetailsCapture },
            ...{
              paymentStatusCapture: this.subcriptionPayment.paymentStatusCapture,
            },
            ...{ productSet: this.subcriptionPayment.selectedPackage.productSet },
            ...{ totalAmount: this.subcriptionPayment.totalAmount },
            ...{ fulltotalAmount: this.subcriptionPayment?.totalPaidAmount },
            ...{ singleCourse: true },
            ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData },
            ...{ failureMessage: subscriptionbillingUtility?.error?.description || "" },
            ...{expiryApplicableOnValidityDate: this.subcriptionPayment?.allCartItems?.[0]?.subscription?.expiryApplicableOnValidityDate}
          });
        }
      });
    });
  }
  getScoreDetailsFormat(element,examdetails){
    let  userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    let saveExamdetail = this.scoreExamdetaildata||scoreExamData.find(v => v.grade == userDetails?.grade?.name?.replace(/[^0-9]/g, ''))
   return {
     "firstName": userDetails?.firstName,
     "lastName":userDetails?.lastName,
     "phone": userDetails?.phone,
     "email": userDetails?.email,
     "userId":userDetails?.userId,
     "mode": "ONLINE",
     "entity": "INFINITYLEARN",
     "platform": "Website",
     "orderid": examdetails?.orderid||'',
     "refid": "",
     "centreid": element?.scoreId,
     "date": examdetails?.date,
     "timeslot": examdetails?.timeslot,
     "couponcode": this.hasCouponCode||element?.code,
     "grade": userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
     "examtype": element?.exams,
     "testype": "SCORETEST",
     "centrename": "",
     "state": "",
     "district": "",
     "city": "",
     "address": "",
     "schoolname": "",
     "examname": "",
     "attempt": 1,
     "ruleid": null,
     "marks": "",
     "duration": saveExamdetail?.duration,
     "subscription": {
       "module": "",
       "id": 0
     },
     "datetime":  examdetails?.datetime
   }
  }

  checkIsUPICorrect(payload: any): any {
    const url = this.apiUrl + `razorpay/validateUPI`;
    return this.httpclient.post(url, payload);
  }

  
  getPhonepePaymentStatus(grade, gatewayOrderId, orderId, userId) {
    const url = this.apiUrl + `phone-pe-integration/check-status?grade=${grade}&merchantTransactionId=${gatewayOrderId}&orderId=${orderId}&pageUrl=${"studentPortal_Subscriptions"}&userId=${userId}`;
    return this.httpclient.get(url);
  }

  checkIsEmiCardCorrect(cardFirst6Digits: any): any {
    const url = this.apiUrl + `razorpay/validate_Card?iin=${cardFirst6Digits}`;
    return this.httpclient.post(url, {});
  }
  getNoCostEmiOffers(): any {
    const url = this.apiUrl + `no_cost_emi_offer/get_emi_offers`;
    return this.httpclient.get(url);
  }

  resendBjajOtp(payload: any) {
    const url = this.apiUrl + `userorders/resendOTP`;
    return this.httpclient.post(url, payload);
  }

  resendBjajOtpV2(payload: any) {
    const url = this.apiUrl + `userorders${environment?.doBajajEncryption ? "/v2" : ""}/resendOTP`;
    return this.httpclient.post(url, payload);
  }

  checkUserSimpleEligibility(payload: any) {
    const url = this.apiUrl + `razorpay/check_eligibility`;
    return this.httpclient.post(url, payload);
  }

  registerJodoStudent(payload: any) {
    const url = this.apiUrl + `judo-integration/userRegister`;
    return this.httpclient.post(url, payload);
  }

  getJodoAccessToken(registration_id) {
    const url = this.apiUrl + `judo-integration/getAccessToken?registrationId=${registration_id}`;
    return this.httpclient.get(url);
  }

  getJodoPaymentStatus(orderId, jodoProductType, jodoStudentId, grade, userId) {
    const url = this.apiUrl + `judo-integration/getProducts?orderId=${orderId}&productType=${jodoProductType}&studentId=${jodoStudentId}&grade=${grade}&userId=${userId}`;
    return this.httpclient.get(url);
  }

  getShopseDecryptedData(encryptionResponse, orderId) {
    const url = this.apiUrl + `shopse-integration/decryption?encryptionResponse=${encryptionResponse}&orderId=${orderId}`;
    return this.httpclient.post(url, {});
  }

  getEarlySalaryOTP(payload) {
    const url = this.apiUrl + `earlySalary-integration/sendOTP`;
    return this.httpclient.post(url, payload);
  }

  verifyEarlySalaryOTP(payload) {
    const url = this.apiUrl + `earlySalary-integration/verifyOTP`;
    return this.httpclient.post(url, payload);
  }

  getEarlySalaryStatus(payload, orderId, grade, userId) {
    const url = this.apiUrl + `earlySalary-integration/getStatus?orderId=${orderId}&grade=${grade}&userId=${userId}`;
    return this.httpclient.post(url, payload);
  }

  getBatchTeacherDetails(batch){
    return this.httpclient.get(this.liveClassapi+'courses/batch'+batch.id+'/classes?type=upcoming').pipe(catchError(this.handleError))
  }

  getTimeSlots(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.post(this.newApiUrl+'rules/timeslots',body,{ headers: headers}).pipe(catchError(this.handleError))
  }
  getEntityScoreTestDateTimeOnline() {
    let payload = {entity:"INFINITYLEARN"}
    const url_ = this.stageeosapi + 'getDateTimeOnline';
    return this.httpclient.get<any>(url_,{params:payload});
  }
  GetScoreScheduleList(){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.get(this.newApiUrl+'score/getScoreSchedules',{ headers: headers}).pipe(catchError(this.handleError))
  }
  getScoreMockTests(querparams){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.get(this.newApiUrl+'score/getScoreMockTests',{ headers: headers,params:querparams}).pipe(catchError(this.handleError))
  }


  getScore23MockTests(querparams){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.get(this.newApiUrl+'score/getScore23MockTests',{ headers: headers,params:querparams}).pipe(catchError(this.handleError))
  }
  
  getTimeSlotData(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      // 'Content-Type': 'application/jsonpexams',
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.post(this.newApiUrl+'exam/rules/details',body,{ headers: headers}).pipe(catchError(this.handleError))
  }

  registerExamSchedule(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    // if(body?.studentid && environment.branch =='staging'){
    //     body.studentid = this.userDetails?.userId ||body.studentid
    //   }
    return this.httpclient.post(this.newApiUrl+'registrations/registerstudentscheduledexam',body,{ headers: headers}).pipe(catchError(this.handleError))
  }

  saveCart(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.post(this.apiUrl+'cart/save',body,{ headers: headers}).pipe(catchError(this.handleError))
  }

  updateCart(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.put(this.apiUrl+'cart/update',body,{ headers: headers}).pipe(catchError(this.handleError))
  }

  updateWishlsit(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.put(this.apiUrl+'wishlist/update',body,{ headers: headers}).pipe(catchError(this.handleError))
  }

  getAllCartItems(param){
    return this.httpclient.get(this.apiUrl+'cart/getAllCartItemByUserId?',{params:param}).pipe(catchError(this.handleError))
  }

  getReccommendations(param){
    return this.httpclient.get(this.apiUrl+'getRecommendationPackages?',{params:param}).pipe(catchError(this.handleError))
  }

  getReccommendationsEmtpyCart(param){
    return this.httpclient.get(this.apiUrl+'recommendations?',{params:param}).pipe(catchError(this.handleError))
  }

  getBatchDetails(batchId){
    return this.httpclient.get(this.liveClassapi+'batches/'+batchId).pipe(catchError(this.handleError))
  }

  checkBatchEnrollment(batchId){
    return this.httpclient.get(this.liveClassapi+'batches/checkEnrollment/'+batchId).pipe(catchError(this.handleError))
  }

  deleteFromCart(cartid){
    let url=`${this.apiUrl}cart/delete?cartId=${cartid}`
    return this.httpclient.delete(url);
  }

  getAllWishlistItems(param){
    return this.httpclient.get(this.apiUrl+'wishlist/getAllWishlistItemByUserId?',{params:param}).pipe(catchError(this.handleError))
  }

  getAvailability(pkgId){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    // param.access_token=localStorage.getItem('token')
    return this.httpclient.get(`${this.apiUrl}packages/getPackageAndSubcriptionDetailByPackageId?packageId=${pkgId}`,{ headers: headers}).pipe(catchError(this.handleError))
  }

  addInWishlist(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.httpclient.post(this.apiUrl+'wishlist/save',body,{ headers: headers}).pipe(catchError(this.handleError));
  }

  updateRemovedCartItem(body) {
    return this.httpclient.put(this.apiUrl+`cart/updateCartToastrStatus?cartId=${body.cartId}&status=${body.status}`, {}).pipe(catchError(this.handleError));
  }

  deleteWishlistItem(wishlistId){
    let url=`${this.apiUrl}wishlist/delete?WishlistId=${wishlistId}`
    return this.httpclient.delete(url);
  }


  getAllPaymentInfo(param){
    return this.httpclient.get(this.apiUrl+'packages/getPartpaymentDetailsByPackageSubscriptionIdArray?',{params:param}).pipe(catchError(this.handleError))
  }

  createCartOrder(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    body.userPlatform = body?.portal||'studentportal';
    return this.httpclient.post(this.apiUrl+'userorders/createUserCartOrder',body,{ headers: headers}).pipe(catchError(this.handleError));
  }

  changeSubscription(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    body.userPlatform = body?.portal||'studentportal';
    return this.httpclient.post(this.apiUrl+'userorders/changeSubscription',body,{ headers: headers}).pipe(catchError(this.handleError));
  }

  createCartOrderV2(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    body.userPlatform = body?.portal||'studentportal';
    return this.httpclient.post(this.apiUrl+`userorders${environment?.doBajajEncryption ? "/v2" : ""}/createUserCartOrder`,body,{ headers: headers}).pipe(catchError(this.handleError));
  }

  createCartOrderV3(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    body.userPlatform = body?.portal||'studentportal';
    let url = environment?.useV1API ? this.apiUrl+'userorders/createUserCartOrder' : this.apiUrl+`userorders/v2/createUserCartOrder`;
    return this.httpclient.post(url,body,{ headers: headers}).pipe(catchError(this.handleError));
  }

  updateDeleteFromWishlist(body) {
    // return this.httpclient.put(this.apiUrl+`cart/updateCartToastrStatus?cartId=${body.cartId}&status=${body.status}`, {}).pipe(catchError(this.handleError));
    return this.httpclient.put(this.apiUrl+`wishlist/updateWishlistToastrStatus?status=${body.status}&wishListId=${body.wishListId}`, {}).pipe(catchError(this.handleError));
  }
  getSpecialDiscountSubscription(params){
    return this.httpclient.get(this.apiUrl+'package-subscription/getSpecialDiscountSubscription',{params:params}).pipe(catchError(this.handleError))

  }

  getExistPackagesOrderDetail(packId){
    this.userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    return this.httpclient.get(this.apiUrl+`packages/getExistPackagesOrderDetail?packageId=${packId}&user_id=${this.userDetails?.userId}`,).pipe(catchError(this.handleError))
  }
sendSubscriptionLSQ(eventID,mPayload){
  let userDataForFirebase = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
  let currentDate = moment().format('DD/MM/YYYY');
  this.firebaseService.getSqsValue().then((firebaseRSP) => {
    this.userService.sendSQSMsgOptim(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,mPayload,eventID);
  }).catch((e) => {
    console.log(e);
  });

}
  convertToEmi(body:any){
    return this.httpclient.put(this.apiUrl+'userorders/convertPaymentToEMI',body).pipe(catchError(this.handleError))
  }
  openAlreadypaidPopup(){
    const config: MatDialogConfig = {
      width: '439px'
    };
    const dialogRef = this.matdialog.open(PaymentalreadypaidComponent, config);
    dialogRef.afterClosed().subscribe(()=>{
      this.router.navigate(['/subscription/partpayment'])
    })
  }

  checkPendingCourseEnrollment(batchId,courseId){
    this.userDetails =   localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    return this.httpclient.get(this.apiUrl+`userorders/checkPendingCourseEnrollment?batchId=${batchId}&courseId=${courseId}&userId=${this.userDetails?.userId}`,).pipe(catchError(this.handleError))
  }

  checkLiveClassEnrollementUsingGET(batchId,courseId){
    let userDetails = localStorage.getItem(apisDataCacheKeys.userDetails) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails)) : {};
    return this.httpclient.get(this.apiUrl + `userorders/is_already_Enrolled?batchId=${batchId}&courseId=${courseId}&userId=${userDetails?.userId}`,).pipe(catchError(this.handleError));
  }

  getUserOrderSubscriptions(grade:number,orderId:number){
    let getuserdetails = this.getuserDetails();
    grade = getuserdetails?.grade?.name?.split('th')?.[0];
    return this.httpclient.get(this.apiUrl+`userorders/get_user_subscriptions?grade=${grade}&orderId=${orderId}`).pipe(catchError(this.handleError))
  }
  scoreExamDataV1(param){
    let url = this.stageeosapi + 'scoreExamDataV1'
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.httpclient.get(url,{params:param})
  }
}
